function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { ClassNames } from '@emotion/core';
import SpecialSelector from '../SpecialSelector/SpecialSelector';
import Avatar from '../Avatar/Avatar';
import List from '../List/List';
import SelectorItem from '../SelectorItem/SelectorItem';
import CurrentSpace from './CurrentSpace';
import { Container, listClass, SpaceSelectorContainer, titleClass, menuPaperClass } from './SpaceSelector.styled';
import { SpaceType } from './propTypes';
import { jsx as ___EmotionJSX } from "@emotion/core";
const MENU_ANCHOR_ORIGIN = {
  vertical: 'top',
  horizontal: 'center'
};
const MENU_TRANSFORM_ORIGIN = {
  vertical: 'top',
  horizontal: 'center'
};

const SpaceSelector = ({
  currentSpace,
  activeSpaces,
  onSpaceSelect
}) => {
  const handleSelect = ({
    item
  }) => {
    if (item && item !== currentSpace.id) {
      const newSpace = activeSpaces.find(space => space.id === item);
      onSpaceSelect({
        newSpace
      });
    }
  };

  return ___EmotionJSX(ClassNames, null, ({
    css
  }) => ___EmotionJSX(Container, null, ___EmotionJSX(SpaceSelectorContainer, null, ___EmotionJSX(SpecialSelector, {
    testID: "space-selector",
    title: currentSpace.name,
    titleClassName: css(titleClass),
    menuPaperClass: css(menuPaperClass),
    onSelect: handleSelect,
    selectorDecoration: ___EmotionJSX(Avatar, {
      name: currentSpace.name,
      src: currentSpace.avatar,
      size: "large"
    }),
    anchorOrigin: MENU_ANCHOR_ORIGIN,
    transformOrigin: MENU_TRANSFORM_ORIGIN,
    compact: true,
    renderChildren: ({
      getItemProps,
      highlightedIndex
    }) => ___EmotionJSX(React.Fragment, null, ___EmotionJSX(CurrentSpace, _extends({
      space: currentSpace,
      highlightedIndex: highlightedIndex
    }, getItemProps({
      item: currentSpace.id
    }))), ___EmotionJSX(ClassNames, null, ({
      css: selectCss
    }) => ___EmotionJSX(List, {
      compact: true,
      className: selectCss(listClass)
    }, activeSpaces.map(({
      id,
      name,
      avatar
    }, index) => ___EmotionJSX(SelectorItem, _extends({
      key: id,
      leftDecoration: ___EmotionJSX(Avatar, {
        size: "medium",
        name: name,
        src: avatar
      }),
      primaryText: name
    }, getItemProps({
      item: id
    }), {
      highlighted: index === highlightedIndex - 1
    }))))))
  }))));
};

SpaceSelector.propTypes = {
  currentSpace: SpaceType.isRequired,
  activeSpaces: PropTypes.arrayOf(SpaceType).isRequired,
  onSpaceSelect: PropTypes.func.isRequired
};
export default SpaceSelector;
//# sourceMappingURL=SpaceSelector.js.map